module.exports = __webpack_public_path__ + "static/img/website.eca8d3fd.png";